/* projects/fitnessforservice/src/app/main-top-menu/main-top-menu.component.css */
.top_menu {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: #0B2D71 !important;
  color: #FFFFFF !important;
  height: 2.8rem !important;
}
a {
  text-decoration: none !important;
}
.active,
a:not(.active):hover {
  background-color: #0066B2 !important;
}
.top_menu__button {
  width: 33%;
  font-family:
    "GothamBold",
    Arial,
    sans-serif;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}
/*# sourceMappingURL=main-top-menu.component.css.map */
